module.exports = __webpack_public_path__ + "static/media/kc-smurfette.622f4511.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/QRCode/images/kittycash/kc-smurfette.png
// module id = 1574
// module chunks = 0